import React, { useState, useEffect } from "react";
import axios from "axios";


const DoctorList = ({ splid,onSelectDoctor , selectedDoctor}) => {
    const [doctors, setDoctors] = useState([]);
    const [filteredDoctors, setFilteredDoctors] = useState([]);
    const [splname, setDepartmentName] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 25; // Show 25 doctors per page

   

    useEffect(() => {
        if (splid) {
            setCurrentPage(1);
            setSearchQuery('');
            // Fetch doctors for the selected department
            axios.get(`https://nhniapp.in/webapi/spls/splslist1db.php?action=doctors&splid=${splid}`)
                .then(response => setDoctors(response.data))
                .catch(error => console.error("Error fetching doctors", error));

                 // Fetch department name
            axios.get(`https://nhniapp.in/webapi/spls/splslist1db.php?action=departments`)
            .then(response => {
                const dept = response.data.find(d => d.splid === splid);
                setDepartmentName(dept ? dept.splname : "Unknown Department");
            })
            .catch(error => console.error("Error fetching department name", error));



        }
    }, [splid]);

    // Handle Search
    useEffect(() => {
        if (searchQuery) {
            const filtered = doctors.filter(inv =>
                inv.doctorsname.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredDoctors(filtered);
            setCurrentPage(1); // Reset pagination when searching
        } else {
            setFilteredDoctors(doctors);
        }
    }, [searchQuery, doctors]);





    // Pagination Logic
    const totalPages = Math.ceil(filteredDoctors.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentDoctors = filteredDoctors.slice(indexOfFirstItem, indexOfLastItem);

    // Generate Pagination Numbers with Ellipsis
    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5; // Total numbers visible including ellipsis

        if (totalPages <= maxPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage > 3) pages.push(1, "...");

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (currentPage < totalPages - 2) pages.push("...", totalPages);
        }

        return pages;
    };

    return (
        <div className="container mt-3">
              <h3 className="text-primary">
                {splid ? `Doctors - ${splname}` : "Select a Department"}
            </h3>
            {splid ? (
                <>

                {/* Search Input */}
                <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search Doctors..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                <div className="dataTable_wrapper">
                    <table className="table table-hover table-striped table-bordered" >
                        <thead className="thead-dark">
                            <tr>
                                <th>Doctor Name</th>
                                <th>Degree</th>
                                <th>OPD-Day</th>
                                <th>Appointment</th>

                            </tr>
                        </thead>
                        <tbody>
               
                        {currentDoctors.length > 0 ? (
                                    currentDoctors.map((inv, index) => (
                        <tr key={inv.doctorid}>
                            <td>{inv.title} {inv.doctorsname}</td>
                            <td>{inv.edudegree} </td>
                            <td>{inv.wname} </td>
                            <td className="text-center">
                { (
                 <button
                 className="btn btn-outline-primary btn-sm"
                 
                 onClick={() => onSelectDoctor(inv)}
               >
                 <span role="img" aria-label="emoji name">
                 📥 </span>Book Appointment
               </button>
                ) }
              </td>
                        </tr>
                     ))
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center">No doctors found</td>
                        </tr>
                        
                    )}
               
                        </tbody>
                </table>
                </div>

                 {/* Pagination Controls */}
                 <nav>
                        <ul className="pagination justify-content-center">
                            {/* First Page Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(1)}>«</button>
                            </li>

                            {/* Previous Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                            </li>

                            {/* Page Numbers with Ellipsis */}
                            {getPageNumbers().map((page, index) =>
                                page === "..." ? (
                                    <li key={index} className="page-item disabled">
                                        <span className="page-link">...</span>
                                    </li>
                                ) : (
                                    <li key={index} className={`page-item ${currentPage === page ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(page)}>
                                            {page}
                                        </button>
                                    </li>
                                )
                            )}

                            {/* Next Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                            </li>

                            {/* Last Page Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(totalPages)}>»</button>
                            </li>
                        </ul>
                    </nav>
                </>
            ) : (
                <p>Select a department to view doctors</p>
            )}
        </div>
    );
};

export default DoctorList;
